@if (selectControl) {
  <div class="modal-with-one-select-container">
    <div class="header-container">
      <h2>{{ 'medicalData.oneRadioModal.health_passport' | translate }}</h2>
      <p>{{ 'medicalData.oneRadioModal.download_here' | translate }}</p>
    </div>

    <app-aria-autocomplete-field
     [label]="'medicalData.oneRadioModal.language' | translate"
     [placeholder]="'medicalData.oneRadioModal.choose_language' | translate"
     [options]="languageOptions"
     [formControl]="selectControl"
    ></app-aria-autocomplete-field>

    <div class="button-container">
      <ds-button class="button-exit" [text]="'buttons.exit' | translate" [styleType]="'empty-main'" [width]="'small'" (click)="exit()"></ds-button>
      <ds-button 
        class="button-download"
        [text]="'buttons.download' | translate"
        [width]="'small'"
        (click)="download()"
        [iconRight]="'/public/assets/images/Download.svg'"
        [isDisabled]="selectControl.invalid"
      ></ds-button>
    </div>
  </div>
}
